/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum TbdPlanPathStatus {
	RuntimeException = 0,
	PathUnreachable = 1,
	NotEnoughMemory = 2,
	NullPointer = 3,
	InvalidArgument = 4,
	Success = 5,
}

/** @format int32 */
export enum TbdPathPlanningMode {
	Farmland = 0,
	RoadNetwork = 1,
	FarmlandNoHeadland = 2,
}

export enum TaskType {
	FollowBehindHarvester = "follow_behind_harvester",
	SendToTruck = "send_to_truck",
	StageCart = "stage_cart",
	UnloadToCart = "unload_to_cart",
	TillageCoverage = "tillage_coverage",
	TillageService = "tillage_service",
}

/** @format int32 */
export enum PathPlanningMode {
	Farmland = 0,
	RoadNetwork = 1,
	FarmlandNoHeadland = 2,
}

/** @format int32 */
export enum GnssMethod {
	NoGps = 0,
	GnssFix = 1,
	DgnssFix = 2,
	PreciseGnss = 3,
	RtkFixedInteger = 4,
	RtkFloat = 5,
	EstimatedMode = 6,
	ManualInput = 7,
	SimulateMode = 8,
	Error = 9,
	Undefined = 10,
}

export interface AreaWithCost {
	/** @format double */
	Cost: number;
	/** GeoJSON MultiPolygon */
	Area: MultiPolygon;
	NonExpanding: boolean;
}

export interface Base64ImageResponseCombined {
	ImageData: string;
	/** @format int32 */
	Width: number;
	/** @format int32 */
	Height: number;
	/** @format double */
	BottomLeftX: number;
	/** @format double */
	BottomLeftY: number;
}

export interface ClothoidPath {
	Metadata?: PathMetadata;
	Origin?: PathOrigin;
	Segments?: ClothoidSegment[] | null;
	Type?: string | null;
}

export interface ClothoidSegment {
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	InitialCurvature: number;
	/** @format double */
	InitialHeading: number;
	/** @format double */
	North: number;
	/** @format double */
	East: number;
	/** @format double */
	Up: number;
	/** @format double */
	Length: number;
	/**
	 * @deprecated
	 * @format double
	 */
	MaxSpeedKph: number;
	/** @format double */
	MaxSpeed: number;
	SegmentMetadata?: string | null;
	SegmentType?: string | null;
}

export interface CoverageGenerationState {
	/** GeoJSON MultiPolygon */
	Coverage: MultiPolygon;
	DrivenPath: Record<string, Point[]>;
	ImplementState?: ImplementState;
	PrevMetric?: GpsMetrics;
}

export interface GeneratedCoverageResponse {
	/** GeoJSON MultiPolygon */
	Coverage: MultiPolygon;
	/** GeoJSON MultiLineString */
	DrivenPath: MultiLineString;
}

/** GeoJSON Geometry */
export type Geometry =
	| Point
	| MultiPoint
	| LineString
	| MultiLineString
	| Polygon
	| MultiPolygon;

export interface GpsLocation {
	/** @format double */
	Longitude: number;
	/** @format double */
	Latitude: number;
	/** @format double */
	Bearing: number;
	/** @format double */
	Speed: number;
	/** @format float */
	Hdop: number;
	/** @format float */
	Pdop: number;
	/** @format int32 */
	NumberOfSVs: number;
	/** @format date-time */
	TimeStamp: string;
	/** @format int32 */
	MilisecondCount?: number | null;
	/** @format double */
	Elevation: number;
	/** @format double */
	RelativeElevation: number;
	Method: GnssMethod;
}

export interface GpsMetrics {
	/** @format date-time */
	Timestamp: string;
	/** GeoJSON Point */
	Location: Point;
	/** @format int32 */
	SegmentId: number;
	/** @format double */
	Bearing: number;
	/** @format double */
	Speed: number;
	/** @format int32 */
	GpsFix: number;
}

export interface ImplementState {
	TractorCenter: GpsLocation;
	ImplementCenter: GpsLocation;
	HitchLocation: GpsLocation;
	/** @format double */
	HitchAngleDegrees: number;
}

/** GeoJSON LineString */
export interface LineString {
	type?: "LineString";
	coordinates?: Position[];
}

export interface MissionPathPlanningRequest {
	/** GeoJSON Point */
	InitialPosition: Point;
	/** @format double */
	InitialHeading: number;
	/** GeoJSON Point */
	FinalPosition: Point;
	/** @format double */
	FinalHeading: number;
	/** @format double */
	TurningRadius: number;
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	MachineSpeed: number;
	PathPlanningMode?: PathPlanningMode;
	/** @format double */
	BoundaryInflationSafetyBuffer?: number | null;
	/** @format int32 */
	NumberOfRings?: number | null;
	/** @format double */
	SpacingBetweenPaths?: number | null;
	EnableSmoothing?: boolean | null;
	SmootherParams?: SmootherParams;
	LethalCoverage?: boolean | null;
	/** @format double */
	CoverageCost?: number | null;
	UseDrivenPath?: boolean | null;
	UsePlannedPath?: boolean | null;
	UseCartPath?: boolean | null;
}

/** GeoJSON MultiLineString */
export interface MultiLineString {
	type?: "MultiLineString";
	coordinates?: LineString[];
}

/** GeoJSON MultiPoint */
export interface MultiPoint {
	type?: "MultiPoint";
	coordinates?: Position[];
}

/** GeoJSON MultiPolygon */
export interface MultiPolygon {
	type?: "MultiPolygon";
	coordinates?: Position[][][];
}

export interface PathMetadata {
	Created?: string | null;
	Datum?: string | null;
	ID?: string | null;
}

export interface PathOrigin {
	/** @format double */
	Alt: number;
	/** @format double */
	Lat: number;
	/** @format double */
	Long: number;
}

export interface PathPlanRequest {
	CompressedBase64Costmap: string;
	/** @format int32 */
	Width: number;
	/** @format int32 */
	Height: number;
	/** GeoJSON Point */
	BottomLeft: Point;
	Config?: SmacPlannerConfig;
}

export interface PathPlanningRequest {
	/** GeoJSON MultiPolygon */
	FieldBoundary: MultiPolygon;
	/** GeoJSON Point */
	InitialPosition: Point;
	/** @format double */
	InitialHeading: number;
	/** GeoJSON Point */
	FinalPosition: Point;
	/** @format double */
	FinalHeading: number;
	/** @format double */
	TurningRadius: number;
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	MachineSpeed: number;
	/** GeoJSON MultiLineString */
	ReferencePaths?: MultiLineString;
	/** GeoJSON MultiPolygon */
	RoadNetwork?: MultiPolygon;
	CostAreas?: AreaWithCost[] | null;
	SpeedZones?: SpeedZone[] | null;
	UseFreeSpace: boolean;
	/** @format int32 */
	FreeSpaceCost?: number | null;
	/** @format double */
	BoundaryInflationBuffer: number;
	PathPlanningMode?: PathPlanningMode;
}

export interface PathPlanningResponse {
	/** GeoJSON LineString */
	SampledPath: LineString;
	ClothoidPath: ClothoidPath;
	/** @format uuid */
	PlanId?: string | null;
}

/** GeoJSON Point */
export interface Point {
	type?: "Point";
	/** Point in 3D space */
	coordinates?: Position;
}

/** GeoJSON Polygon */
export interface Polygon {
	type?: "Polygon";
	coordinates?: Position[][];
}

/**
 * Point in 3D space
 * @maxItems 3
 * @minItems 2
 */
export type Position = number[];

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export interface SmacPlannerConfig {
	/** @format int32 */
	AngleQuantizationBins: number;
	/** @format double */
	Tolerance: number;
	/** @format double */
	MaxPlanningTime: number;
	/** @format int32 */
	MaxIterations: number;
	/** @format int32 */
	MaxOnApproachIterations: number;
	/** @format int32 */
	TerminalCheckingInterval: number;
	DownsampleObstacleHeuristic: boolean;
	CacheObstacleHeuristic: boolean;
	AllowUnknown: boolean;
	/** @format double */
	MinimumTurningRadius: number;
	/** @format double */
	NonStraightPenalty: number;
	/** @format double */
	ChangePenalty: number;
	/** @format double */
	ReversePenalty: number;
	/** @format double */
	CostPenalty: number;
	/** @format double */
	RetrospectivePenalty: number;
	/** @format double */
	AnalyticExpansionRatio: number;
	/** @format double */
	AnalyticExpansionMaxLength: number;
	/** @format double */
	AnalyticExpansionMaxCost: number;
	AnalyticExpansionMaxCostOverride: boolean;
	AllowPrimitiveInterpolation: boolean;
	UseQuadraticCostPenalty: boolean;
	/** @format double */
	LookupTableSize: number;
	/** @format double */
	CostmapResolution: number;
	UseFallbackDistanceHeuristic: boolean;
	ConditionalReversalEnabled: boolean;
	/** @format double */
	InFrontClassificationAngle: number;
	/** @format double */
	FacingClassificationAngle: number;
	EnforceRoutability: boolean;
	/** @format double */
	NavigabilityCheckRayCastLength: number;
	/** @format double */
	SamplesPerMeterRayCast: number;
}

export interface SmootherParams {
	/** @format double */
	NeighborRadius: number;
	/** @format double */
	MinNeighborDistance: number;
	/** @format double */
	IntermediateSampleSpacing: number;
	/** @format int32 */
	CrossTrackSamples: number;
	/** @format double */
	LengthWeight: number;
	/** @format double */
	CurvatureRateWeight: number;
	/** @format double */
	CrossTrackWeight: number;
	/** @format double */
	CurvatureWeight: number;
}

export interface SpeedZone {
	/** @format double */
	Speed: number;
	/** GeoJSON Polygon */
	Area: Polygon;
}

export interface TbdClothoidSegment {
	/** GeoJSON Point */
	InitialPosition: Point;
	/** @format double */
	InitialHeading: number;
	/** @format double */
	CurvatureRate: number;
	/** @format double */
	Length: number;
	/** @format double */
	MaxSpeed: number;
}

export interface TbdCostArea {
	/** GeoJSON MultiPolygon */
	AreaEnu: MultiPolygon;
	/** @format double */
	Cost: number;
	NonExpanding: boolean;
}

export interface TbdPlanningData {
	/** @format uuid */
	Id: string;
	/** @format date-time */
	CreatedAt: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MissionId: string;
	/** @format uuid */
	UserId: string;
	UserEmail?: string | null;
	PlanningMode?: TbdPathPlanningMode;
	/** @format int32 */
	Seed: number;
	/** GeoJSON Point */
	Origin: Point;
	/** GeoJSON Point */
	InitialPositionEnu: Point;
	/** @format double */
	InitialHeading: number;
	/** GeoJSON Point */
	FinalPositionEnu: Point;
	/** @format double */
	FinalHeading: number;
	/** GeoJSON MultiPolygon */
	FieldBoundaryEnu: MultiPolygon;
	/** @format int32 */
	NumberOfRings: number;
	/** @format double */
	BoundaryInflationSafetyBuffer: number;
	/** @format double */
	FirstPathDistanceFromSafetyBuffer: number;
	/** @format double */
	SpacingBetweenPaths: number;
	ReferencePaths: TbdReferencePath[];
	CostAreas: TbdCostArea[];
	SpeedLimitedZones: TbdSpeedLimitedZone[];
	/** @format double */
	TurningRadius: number;
	/** @format double */
	CurvatureWeight: number;
	/** @format double */
	MachineSpeed: number;
	UseOpenSpace: boolean;
	/** @format double */
	OpenSpaceCost: number;
	EnableSmoothing: boolean;
	SmootherParams?: TbdSmootherParams;
	PlanStatus: TbdPlanPathStatus;
	/** GeoJSON LineString */
	SampledPathEnu?: LineString;
	ClothoidPath?: TbdClothoidSegment[] | null;
}

export interface TbdPlanningDataSummary {
	/** @format uuid */
	Id: string;
	/** @format date-time */
	CreatedAt: string;
	/** @format uuid */
	AccountId: string;
	/** @format uuid */
	MissionId: string;
	/** @format uuid */
	UserId: string;
	UserEmail?: string | null;
	PlanningMode?: TbdPathPlanningMode;
	PlanStatus: TbdPlanPathStatus;
	/** @format uuid */
	TaskId: string | null;
	TaskType: TaskType;
}

export interface TbdReferencePath {
	/** GeoJSON LineString */
	PathEnu: LineString;
	/** @format double */
	Cost: number;
}

export interface TbdSmootherParams {
	/** @format double */
	NeighborRadius: number;
	/** @format double */
	MinNeighborDistance: number;
	/** @format double */
	IntermediateSampleSpacing: number;
	/** @format int32 */
	CrossTrackSamples: number;
	/** @format double */
	LengthWeight: number;
	/** @format double */
	CurvatureRateWeight: number;
	/** @format double */
	CrossTrackWeight: number;
	/** @format double */
	CurvatureWeight: number;
}

export interface TbdSpeedLimitedZone {
	/** GeoJSON Polygon */
	AreaEnu: Polygon;
	/** @format double */
	SpeedLimit: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseFormat;
	/** request body */
	body?: unknown;
	/** base url */
	baseUrl?: string;
	/** request cancellation token */
	cancelToken?: CancelToken;
}

export type RequestParams = Omit<
	FullRequestParams,
	"body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
	baseUrl?: string;
	baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
	securityWorker?: (
		securityData: SecurityDataType | null,
	) => Promise<RequestParams | void> | RequestParams | void;
	customFetch?: typeof fetch;
}

export interface HttpResponse<
	D extends unknown,
	E extends unknown = unknown,
> extends Response {
	data: D;
	error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
	Json = "application/json",
	JsonApi = "application/vnd.api+json",
	FormData = "multipart/form-data",
	UrlEncoded = "application/x-www-form-urlencoded",
	Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
	public baseUrl: string = "";
	private securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
	private abortControllers = new Map<CancelToken, AbortController>();
	private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
		fetch(...fetchParams);

	private baseApiParams: RequestParams = {
		credentials: "same-origin",
		headers: {},
		redirect: "follow",
		referrerPolicy: "no-referrer",
	};

	constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
		Object.assign(this, apiConfig);
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	protected encodeQueryParam(key: string, value: any) {
		const encodedKey = encodeURIComponent(key);
		return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
	}

	protected addQueryParam(query: QueryParamsType, key: string) {
		return this.encodeQueryParam(key, query[key]);
	}

	protected addArrayQueryParam(query: QueryParamsType, key: string) {
		const value = query[key];
		return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
	}

	protected toQueryString(rawQuery?: QueryParamsType): string {
		const query = rawQuery || {};
		const keys = Object.keys(query).filter(
			key => "undefined" !== typeof query[key],
		);
		return keys
			.map(key =>
				Array.isArray(query[key])
					? this.addArrayQueryParam(query, key)
					: this.addQueryParam(query, key),
			)
			.join("&");
	}

	protected addQueryParams(rawQuery?: QueryParamsType): string {
		const queryString = this.toQueryString(rawQuery);
		return queryString ? `?${queryString}` : "";
	}

	private contentFormatters: Record<ContentType, (input: any) => any> = {
		[ContentType.Json]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.JsonApi]: (input: any) =>
			input !== null &&
			(typeof input === "object" || typeof input === "string")
				? JSON.stringify(input)
				: input,
		[ContentType.Text]: (input: any) =>
			input !== null && typeof input !== "string"
				? JSON.stringify(input)
				: input,
		[ContentType.FormData]: (input: any) => {
			if (input instanceof FormData) {
				return input;
			}

			return Object.keys(input || {}).reduce((formData, key) => {
				const property = input[key];
				formData.append(
					key,
					property instanceof Blob
						? property
						: typeof property === "object" && property !== null
							? JSON.stringify(property)
							: `${property}`,
				);
				return formData;
			}, new FormData());
		},
		[ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
	};

	protected mergeRequestParams(
		params1: RequestParams,
		params2?: RequestParams,
	): RequestParams {
		return {
			...this.baseApiParams,
			...params1,
			...(params2 || {}),
			headers: {
				...(this.baseApiParams.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	protected createAbortSignal = (
		cancelToken: CancelToken,
	): AbortSignal | undefined => {
		if (this.abortControllers.has(cancelToken)) {
			const abortController = this.abortControllers.get(cancelToken);
			if (abortController) {
				return abortController.signal;
			}
			return void 0;
		}

		const abortController = new AbortController();
		this.abortControllers.set(cancelToken, abortController);
		return abortController.signal;
	};

	public abortRequest = (cancelToken: CancelToken) => {
		const abortController = this.abortControllers.get(cancelToken);

		if (abortController) {
			abortController.abort();
			this.abortControllers.delete(cancelToken);
		}
	};

	public request = async <T = any, E = any>({
		body,
		secure,
		path,
		type,
		query,
		format,
		baseUrl,
		cancelToken,
		...params
	}: FullRequestParams): Promise<HttpResponse<T, E>> => {
		const secureParams =
			((typeof secure === "boolean"
				? secure
				: this.baseApiParams.secure) &&
				this.securityWorker &&
				(await this.securityWorker(this.securityData))) ||
			{};
		const requestParams = this.mergeRequestParams(params, secureParams);
		const queryString = query && this.toQueryString(query);
		const payloadFormatter =
			this.contentFormatters[type || ContentType.Json];
		const responseFormat = format || requestParams.format;

		return this.customFetch(
			`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
			{
				...requestParams,
				headers: {
					...(requestParams.headers || {}),
					...(type && type !== ContentType.FormData
						? { "Content-Type": type }
						: {}),
				},
				signal:
					(cancelToken
						? this.createAbortSignal(cancelToken)
						: requestParams.signal) || null,
				body:
					typeof body === "undefined" || body === null
						? null
						: payloadFormatter(body),
			},
		).then(async response => {
			const r = response as HttpResponse<T, E>;
			r.data = null as unknown as T;
			r.error = null as unknown as E;

			const responseToParse = responseFormat
				? response.clone()
				: response;
			const data = !responseFormat
				? r
				: await responseToParse[responseFormat]()
						.then(data => {
							if (r.ok) {
								r.data = data;
							} else {
								r.error = data;
							}
							return r;
						})
						.catch(e => {
							r.error = e as E;
							return r;
						});

			if (cancelToken) {
				this.abortControllers.delete(cancelToken);
			}

			if (!response.ok) {
				const error = Object.assign(
					new Error(
						`HTTP ${data.status}: ${data.statusText || "Error"}`,
					),
					{
						status: data.status,
						statusText: data.statusText,
						data: data.data,
						error: data.error,
						response: data,
						json: data.json.bind(data),
						text: data.text.bind(data),
					},
				);

				throw error;
			}
			return data;
		});
	};
}

/**
 * @title FlightPathOpenGlApi
 * @version 1.0
 */
export class Api<
	SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
	glApi = {
		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapLayerList
		 * @request GET:/gl-api/costmap/layer
		 */
		costmapLayerList: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				layerType?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api/costmap/layer`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapLayerBinaryList
		 * @request GET:/gl-api/costmap/layer-binary
		 */
		costmapLayerBinaryList: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				layerType?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api/costmap/layer-binary`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapCombinedList
		 * @request GET:/gl-api/costmap/combined
		 */
		costmapCombinedList: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<Base64ImageResponseCombined, any>({
				path: `/gl-api/costmap/combined`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapImageList
		 * @request GET:/gl-api/costmap/image
		 */
		costmapImageList: (
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api/costmap/image`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageGenerateList
		 * @request GET:/gl-api/coverage/generate
		 */
		coverageGenerateList: (
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				implementId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format double */
				simplifyTolerance?: number;
				/** @format int32 */
				polygonUnionBatchSize?: number;
				/** @format int32 */
				lineSimplifyBatchSize?: number;
				/** @format double */
				distanceThreshold?: number;
				/** @format double */
				angleThreshold?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<GeneratedCoverageResponse, ProblemDetails | void>({
				path: `/gl-api/coverage/generate`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Coverage
		 * @name CoverageGenerateCreate
		 * @request POST:/gl-api/coverage/generate
		 */
		coverageGenerateCreate: (
			data: CoverageGenerationState,
			query?: {
				/** @format uuid */
				machineId?: string;
				/** @format uuid */
				implementId?: string;
				/** @format date-time */
				startTime?: string;
				/** @format date-time */
				endTime?: string;
				/** @format double */
				simplifyTolerance?: number;
				/** @format int32 */
				polygonUnionBatchSize?: number;
				/** @format int32 */
				lineSimplifyBatchSize?: number;
				/** @format double */
				distanceThreshold?: number;
				/** @format double */
				angleThreshold?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<CoverageGenerationState, ProblemDetails | void>({
				path: `/gl-api/coverage/generate`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathList
		 * @request GET:/gl-api/path-planning/{missionId}/path
		 */
		pathPlanningPathList: (
			missionId: string,
			query?: {
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/** @format double */
				startLat?: number;
				/** @format double */
				startLon?: number;
				/** @format double */
				startHeading?: number;
				/** @format double */
				endLat?: number;
				/** @format double */
				endLon?: number;
				/** @format double */
				endHeading?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api/path-planning/${missionId}/path`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathCreate
		 * @request POST:/gl-api/path-planning/{missionId}/path
		 */
		pathPlanningPathCreate: (
			missionId: string,
			data: SmacPlannerConfig,
			query?: {
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/** @format double */
				startLat?: number;
				/** @format double */
				startLon?: number;
				/** @format double */
				startHeading?: number;
				/** @format double */
				endLat?: number;
				/** @format double */
				endLon?: number;
				/** @format double */
				endHeading?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api/path-planning/${missionId}/path`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathCreate2
		 * @request POST:/gl-api/path-planning/path
		 * @originalName pathPlanningPathCreate
		 * @duplicate
		 */
		pathPlanningPathCreate2: (
			data: PathPlanRequest,
			query?: {
				/** @format double */
				startX?: number;
				/** @format double */
				startY?: number;
				/** @format double */
				startAngle?: number;
				/** @format double */
				endX?: number;
				/** @format double */
				endY?: number;
				/** @format double */
				endAngle?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api/path-planning/path`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanCreate
		 * @request POST:/gl-api/path-planning/plan
		 */
		pathPlanningPlanCreate: (
			data: PathPlanningRequest,
			params: RequestParams = {},
		) =>
			this.request<PathPlanningResponse, any>({
				path: `/gl-api/path-planning/plan`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanCreate2
		 * @request POST:/gl-api/path-planning/{missionId}/plan
		 * @originalName pathPlanningPlanCreate
		 * @duplicate
		 */
		pathPlanningPlanCreate2: (
			missionId: string,
			data: MissionPathPlanningRequest,
			params: RequestParams = {},
		) =>
			this.request<PathPlanningResponse, any>({
				path: `/gl-api/path-planning/${missionId}/plan`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanList
		 * @request GET:/gl-api/path-planning/{missionId}/plan
		 */
		pathPlanningPlanList: (missionId: string, params: RequestParams = {}) =>
			this.request<TbdPlanningDataSummary[], any>({
				path: `/gl-api/path-planning/${missionId}/plan`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanDetail
		 * @request GET:/gl-api/path-planning/{missionId}/plan/{planId}
		 */
		pathPlanningPlanDetail: (
			missionId: string,
			planId: string,
			params: RequestParams = {},
		) =>
			this.request<TbdPlanningData, any>({
				path: `/gl-api/path-planning/${missionId}/plan/${planId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	glApiMachine = {
		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapLayerList
		 * @request GET:/gl-api-machine/{machineId}/costmap/layer
		 */
		costmapLayerList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				layerType?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api-machine/${machineId}/costmap/layer`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapLayerBinaryList
		 * @request GET:/gl-api-machine/{machineId}/costmap/layer-binary
		 */
		costmapLayerBinaryList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/**
				 * @format int32
				 * @default 0
				 */
				layerType?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api-machine/${machineId}/costmap/layer-binary`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapCombinedList
		 * @request GET:/gl-api-machine/{machineId}/costmap/combined
		 */
		costmapCombinedList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<Base64ImageResponseCombined, any>({
				path: `/gl-api-machine/${machineId}/costmap/combined`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags Costmap
		 * @name CostmapImageList
		 * @request GET:/gl-api-machine/{machineId}/costmap/image
		 */
		costmapImageList: (
			machineId: string,
			query?: {
				/** @format uuid */
				missionId?: string;
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<void, any>({
				path: `/gl-api-machine/${machineId}/costmap/image`,
				method: "GET",
				query: query,
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathList
		 * @request GET:/gl-api-machine/{machineId}/path-planning/{missionId}/path
		 */
		pathPlanningPathList: (
			missionId: string,
			machineId: string,
			query?: {
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/** @format double */
				startLat?: number;
				/** @format double */
				startLon?: number;
				/** @format double */
				startHeading?: number;
				/** @format double */
				endLat?: number;
				/** @format double */
				endLon?: number;
				/** @format double */
				endHeading?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api-machine/${machineId}/path-planning/${missionId}/path`,
				method: "GET",
				query: query,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathCreate
		 * @request POST:/gl-api-machine/{machineId}/path-planning/{missionId}/path
		 */
		pathPlanningPathCreate: (
			missionId: string,
			machineId: string,
			data: SmacPlannerConfig,
			query?: {
				/** @format double */
				baseLatitude?: number;
				/** @format double */
				baseLongitude?: number;
				/** @format double */
				baseAltitude?: number;
				/** @format double */
				startLat?: number;
				/** @format double */
				startLon?: number;
				/** @format double */
				startHeading?: number;
				/** @format double */
				endLat?: number;
				/** @format double */
				endLon?: number;
				/** @format double */
				endHeading?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api-machine/${machineId}/path-planning/${missionId}/path`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPathCreate2
		 * @request POST:/gl-api-machine/{machineId}/path-planning/path
		 * @originalName pathPlanningPathCreate
		 * @duplicate
		 */
		pathPlanningPathCreate2: (
			machineId: string,
			data: PathPlanRequest,
			query?: {
				/** @format double */
				startX?: number;
				/** @format double */
				startY?: number;
				/** @format double */
				startAngle?: number;
				/** @format double */
				endX?: number;
				/** @format double */
				endY?: number;
				/** @format double */
				endAngle?: number;
			},
			params: RequestParams = {},
		) =>
			this.request<LineString, void>({
				path: `/gl-api-machine/${machineId}/path-planning/path`,
				method: "POST",
				query: query,
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanCreate
		 * @request POST:/gl-api-machine/{machineId}/path-planning/plan
		 */
		pathPlanningPlanCreate: (
			machineId: string,
			data: PathPlanningRequest,
			params: RequestParams = {},
		) =>
			this.request<PathPlanningResponse, any>({
				path: `/gl-api-machine/${machineId}/path-planning/plan`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanCreate2
		 * @request POST:/gl-api-machine/{machineId}/path-planning/{missionId}/plan
		 * @originalName pathPlanningPlanCreate
		 * @duplicate
		 */
		pathPlanningPlanCreate2: (
			missionId: string,
			machineId: string,
			data: MissionPathPlanningRequest,
			params: RequestParams = {},
		) =>
			this.request<PathPlanningResponse, any>({
				path: `/gl-api-machine/${machineId}/path-planning/${missionId}/plan`,
				method: "POST",
				body: data,
				type: ContentType.Json,
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanList
		 * @request GET:/gl-api-machine/{machineId}/path-planning/{missionId}/plan
		 */
		pathPlanningPlanList: (
			missionId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<TbdPlanningDataSummary[], any>({
				path: `/gl-api-machine/${machineId}/path-planning/${missionId}/plan`,
				method: "GET",
				format: "json",
				...params,
			}),

		/**
		 * No description
		 *
		 * @tags PathPlanning
		 * @name PathPlanningPlanDetail
		 * @request GET:/gl-api-machine/{machineId}/path-planning/{missionId}/plan/{planId}
		 */
		pathPlanningPlanDetail: (
			missionId: string,
			planId: string,
			machineId: string,
			params: RequestParams = {},
		) =>
			this.request<TbdPlanningData, any>({
				path: `/gl-api-machine/${machineId}/path-planning/${missionId}/plan/${planId}`,
				method: "GET",
				format: "json",
				...params,
			}),
	};
	health = {
		/**
		 * No description
		 *
		 * @tags HealthCheck
		 * @name HealthList
		 * @request GET:/health
		 */
		healthList: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/health`,
				method: "GET",
				...params,
			}),
	};
}
